import { Card, Pagination } from "antd";
import React, { useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

type Props = { data: any };

interface AnnounceCardComponentProps {
    data: any[]; // ปรับประเภทตามข้อมูลจริงที่คุณมี
}

const AnnounceCardComponent: React.FC<Props> = ({ data }) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const onShowSizeChange = (current: number, size: number) => {
        setPageSize(size);
        setCurrentPage(1);
    };

    // คำนวณข้อมูลที่จะแสดงในหน้าปัจจุบัน
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    
    const sortData = data.sort(
                      (a: any, b: any) =>
                        new Date(b.Memo_RequestDate).getTime() -
                        new Date(a.Memo_RequestDate).getTime()
                    );
    const currentData = sortData.slice(startIndex, endIndex);
    return (
        <>
            <div className="loginImge2">
                <div
                    style={{
                        marginLeft: "150px",
                        marginRight: "150px",
                        alignItems: "center",
                        marginTop: "20px",
                    }}
                >
                    <Card className="custom-card2">
                        <div>
                            <h4 style={{ color: "#025A9D" }}>
                                {searchParams.get("Id") && data[0]?.ประเภทของประกาศ} ({data.length})
                            </h4>
                            {currentData?.length > 0 ? (
                                currentData.map((item: any, index: number) => (
                                    <div key={index} className="custom-card3">
                                        <span className="card-date">
                                            {item.Memo_RequestDate
                                                ? item.Memo_RequestDate.split('T')[0]
                                                : "N/A"}
                                        </span>
                                        <a
                                            href={
                                                item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] || "#"
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                fontSize: "18px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            {item["ชื่อประกาศ Subject"]}
                                        </a>
                                        <p
                                            style={{
                                                fontSize: "15px",
                                                maxWidth: "1200px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {item["ข้อมูลรายละเอียดในใบประกาศ"] || "No details available"}
                                        </p>
                                        <button className="details-button" onClick={() => {
                                            const url = item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] || "#";
                                            window.open(url, "_blank");
                                        }}>รายละเอียดเพิ่มเติม</button>
                                    </div>
                                ))
                            ) : (
                                <p>No announcements available.</p>
                            )}
                        </div>
                        <Pagination
                            showSizeChanger
                            onShowSizeChange={onShowSizeChange}
                            defaultCurrent={1}
                            current={currentPage}
                            pageSize={pageSize}
                            total={data.length}
                            onChange={handlePageChange}
                            style={{ marginTop: "20px", textAlign: "center" }}
                        />
                    </Card>
                </div>
            </div>
        </>
    );
};

export default AnnounceCardComponent;
